/* gs-cart-engraving.js — minimal renderer + save for Engraving Text/Placement Notes */
(function () {
  const root = () => (Shopify.routes && Shopify.routes.root) || '/';
  const esc  = s => String(s||'').replace(/[&<>]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;'}[m]));
  const escA = s => String(s||'').replace(/"/g,'&quot;');
  const strip= s => { const d=document.createElement('div'); d.innerHTML=s||''; return d.textContent||''; };
  async function cart(){ const r=await fetch(root()+'cart.js',{credentials:'include'}); if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); }
  async function change(id,properties){ const r=await fetch(root()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,properties})}); if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); }
  function idxs(p){ const re=/(Engraving Text|Placement Notes|Secondary Logo) - (\d+)$/; const ns=Object.keys(p||{}).map(k=>(k.match(re)||[])[2]).filter(Boolean).map(Number); const max=ns.length?Math.max(...ns):1; return Array.from({length:max},(_,i)=>i+1); }
  function personalized(p,list){ const hasPrimary=!!p['Primary Logo - 1']; return list.some(i=> strip(p['Engraving Text - '+i]||'').trim() || (p['Placement Notes - '+i]||'').trim() || (p['Secondary Logo - '+i]||'').trim() || (hasPrimary&&(i===1||!!p['Use Primary Logo - '+i])) ); }
  function badge(ok){ return `<span style="display:inline-flex;gap:.4em;padding:.3em .55em;border:1px solid ${ok?'#a7f3d0':'#fed7aa'};border-radius:.6em;background:${ok?'#ecfdf5':'#fff7ed'};color:${ok?'#065f46':'#92400e'}"><b>${ok?'✓':'!'}</b> ${ok?'Personalized':'Personalization incomplete'}</span>`; }

  async function render(mount){
    let c; try { c = await cart(); } catch(e){ mount.innerHTML = `<div style="background:#fff7ed;border:1px solid #fed7aa;padding:10px;border-radius:8px;">Could not load cart. ${esc(e.message||e)}</div>`; return; }
    const mode = (mount.getAttribute('data-mode')||'summary').toLowerCase();

    function itemCard(it){
      const p = it.properties||{}, list = idxs(p), ok = personalized(p,list);
      const head = `<div style="display:flex;justify-content:space-between;align-items:center;gap:.75em">
        <div><strong>${esc(it.product_title)}</strong>${it.variant_title?' — '+esc(it.variant_title):''} (×${it.quantity})</div>
        ${badge(ok)}
      </div>`;
      const lines = list.map(i => {
        const txt = strip((p['Engraving Text - '+i]||'')+'');
        const notes = (p['Placement Notes - '+i]||'')+'';
        return `<div style="border:1px solid #eef0f2;border-radius:8px;padding:.6em;margin:.5em 0">
          ${list.length>1?`<div style="font-weight:600;margin-bottom:.25em">Item ${i}</div>`:''}
          <div style="font-size:.92rem;color:#555"><b>Text:</b> ${txt?esc(txt):'<em>None</em>'}${notes?` · <b>Notes:</b> ${esc(notes)}`:''}</div>
        </div>`;
      }).join('');

      if (mode==='summary') {
        return `<div style="border:1px solid #e5e7eb;border-radius:10px;padding:12px;margin:10px 0">${head}</div>`;
      }

      // edit mode
      const editors = list.map(i => `
        <fieldset data-i="${i}" style="border:0;padding:0;margin:.4em 0">
          ${list.length>1?`<div style="font-weight:600;margin:.25em 0">Item ${i}</div>`:''}
          <label style="display:block;margin:.35em 0">Engraving Text (plain)
            <textarea rows="2" data-key="Engraving Text - ${i}" style="width:100%;padding:.55em;border:1px solid #d1d5db;border-radius:8px">${esc(strip(p['Engraving Text - '+i]||''))}</textarea>
          </label>
          <label style="display:block;margin:.35em 0">Placement Notes
            <input type="text" data-key="Placement Notes - ${i}" value="${escA(p['Placement Notes - '+i]||'')}" style="width:100%;padding:.55em;border:1px solid #d1d5db;border-radius:8px">
          </label>
        </fieldset>`).join('');

      const backUrl = it.url ? `${it.url}?from=cart` : null;
      return `<div class="gs-card" data-key="${it.key}" style="border:1px solid #e5e7eb;border-radius:10px;padding:12px;margin:10px 0">
        ${head}
        <div style="margin-top:.5em">${lines}</div>
        <details style="margin-top:.4em">
          <summary style="cursor:pointer;font-weight:600">Quick Edit Personalization</summary>
          ${editors}
          <div style="display:flex;gap:.5em;margin-top:.6em">
            <button type="button" class="gs-save" style="padding:.5em .8em;border:1px solid #d1d5db;border-radius:8px;background:#fff;cursor:pointer">Save</button>
            ${backUrl?`<a href="${escA(backUrl)}" style="padding:.5em .8em;border:1px solid #d1d5db;border-radius:8px;background:#fff;display:inline-block">Edit on product page</a>`:''}
          </div>
          <div style="margin-top:.35em;color:#666;font-size:.9rem">Tip: Quick Edit saves plain text. For styled text and live preview, use the product page.</div>
        </details>
      </div>`;
    }

    const banner = (c.items||[]).some(it => !personalized(it.properties||{}, idxs(it.properties||{})))
      ? `<div style="background:#fff7ed;border:1px solid #fed7aa;color:#92400e;border-radius:8px;padding:10px;margin:10px 0;font-size:.92rem">Some items lack personalization. You can still check out, or personalize now.</div>`
      : `<div></div>`;

    mount.innerHTML = banner + (c.items||[]).map(itemCard).join('');

    // save handlers (edit mode only)
    if (mode==='edit') {
      mount.querySelectorAll('.gs-card').forEach(card => {
        const key = card.getAttribute('data-key');
        card.querySelector('.gs-save')?.addEventListener('click', async () => {
          try {
            const fresh = await cart();
            const it = fresh.items.find(i => i.key === key);
            if (!it) return;
            const merged = Object.assign({}, it.properties||{});
            card.querySelectorAll('[data-key]').forEach(el => merged[el.getAttribute('data-key')] = (el.value||'').trim());
            await change(key, merged);
            await render(mount); // re-render banner + card
          } catch(e){ alert('Save failed. ' + (e.message||e)); }
        });
      });
    }
  }

  // scan mounts now + on DOM updates
  function scan(){
    document.querySelectorAll('[data-gs-engraving]').forEach(el => { if (!el.__gsBound){ el.__gsBound=true; render(el); }});
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
})();
